import { Box, Button, Card, ListItem, Select, TextField } from '@material-ui/core'

import { MarketplaceMediaUploadButton } from './MarketplaceMediaUploadButton'
import React from 'react'
import { Spacer } from '@vestaboard/installables'

interface IFeaturedItemOption {
  id: string
  label: string
}

interface IFeaturedItemRow {
  id: string | null
  image: string | null
  imagePreviewUrl: string | null
  description: string | null
  options: IFeaturedItemOption[]
  onChangeId: (id: string) => any
  onChangeImage: (image: string) => any
  onChangeDescription: (description: string) => any
  onDelete?: () => any
  aspectRatio?: number
  onChangeVariantImage?: (image: string) => any
  variantImage?: string | null
  variantImagePreviewUrl?: string | null
  isNote?: boolean
}

type FeaturedItemRow = IFeaturedItemRow

export const FeaturedItem: React.FC<FeaturedItemRow> = props => {
  const { onDelete } = props

  return (
    <Card style={{ marginBottom: 24, marginRight: 24, width: 448, padding: 24 }}>
      <Select
        variant='outlined'
        placeholder='Marketplace listing'
        value={props.id}
        onChange={e => props.onChangeId(e.target.value as string)}>
        {props.options
          .sort((d1, d2) => d1.label.localeCompare(d2.label))
          .map(option => (
            <ListItem value={option.id}>{option.label}</ListItem>
          ))}
      </Select>
      <Spacer size='large' />
      <Box>
        <MarketplaceMediaUploadButton
          previewUrl={props.imagePreviewUrl}
          onUpload={id => props.onChangeImage(id)}
          aspectRatio={props.aspectRatio}
          marketplaceListingId={props.id}
          isNote={props.isNote}
        />
      </Box>
      {props.onChangeVariantImage ? (
        <Box>
          <Spacer size='large' />
          <MarketplaceMediaUploadButton
            previewUrl={props.variantImagePreviewUrl}
            onUpload={id => props.onChangeVariantImage?.(id)}
            aspectRatio={16 / 9}
            marketplaceListingId={props.id}
            isNote={props.isNote}
          />
        </Box>
      ) : null}
      <Spacer size='large' />
      <Box>
        <TextField
          multiline
          fullWidth
          variant='outlined'
          value={props.description}
          onChange={e => props.onChangeDescription(e.target.value)}
          placeholder='Description'
        />
      </Box>
      {onDelete && (
        <Box>
          <Spacer size='large' />
          <Button variant='outlined' onClick={onDelete}>
            Remove
          </Button>
        </Box>
      )}
    </Card>
  )
}
